import { LupaIcon } from "assets/icons/LupaIcon";
import { showErrorToast } from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { Pagination } from "components/Pagination/Pagination";
import { DEFAULT_LIMIT_PAGINATION } from "constants/appConstants";
import { useFormik } from "formik";
import { NivelI } from "interfaces/Nivel";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getNivelesPaginado } from "services/niveles";
import { AppDispatch, RootState } from "store/store";
import { NivelRowActions } from "./NivelTable/NivelRowActions";
import { NivelTable } from "./NivelTable/NivelTable";
import { NivelABM } from "./NivelABM/NivelABM";
import { log } from "console";

export const Nivel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [elementos, setElementos] = useState<NivelI[]>();
  const [cantidad, setCantidad] = useState<number>();
  const [page, setPage] = useState<number>();
  const [limit, setLimit] = useState<number>();

  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const [showModalABM, setShowModalABM] = useState(false);
  const [actionType, setActionType] = useState<"create" | "edit" | undefined>();
  const [selectedElement, setSelectedElement] = useState<NivelI | undefined>();

  const initialValues = {
    id: "",
    nombre: "",
  };

  const { values, handleChange, resetForm } = useFormik({
    initialValues,
    onSubmit: () => {},
  });

  const searchNiveles = async (params?: {
    filtros?: { [key: string]: any };
  }) => {
    try {
      setIsLoading(true);
      const response = await getNivelesPaginado({ ...params?.filtros });
      setElementos(response.elementos);
      setCantidad(response.cantidad);
      setPage(response.page);
      setLimit(params?.filtros?.limit ?? DEFAULT_LIMIT_PAGINATION);
    } catch (err) {
      console.log("Messi", err);

      showErrorToast("No fue posible cargar los Niveles");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModalABM(false);
    setTimeout(() => setActionType(undefined), 500);
  };

  const handleEdit = (elemento: NivelI) => {
    setActionType("edit");
    setSelectedElement(elemento);
    setShowModalABM(true);
  };

  const handleCreate = () => {
    setActionType("create");
    setShowModalABM(true);
  };

  const handleChangePagination = (newFiltros: {
    [key: string]: string | number;
  }) => {
    searchNiveles({ filtros: { ...values, ...newFiltros } });
  };

  const handleClearFilters = () => {
    resetForm();
    searchNiveles();
  };

  const handleChangeWithResetPage = (pageOne: any) => {
    setPage(1);
    handleChange(pageOne);
  };

  const refreshTable = () => {
    setPage(1);
    searchNiveles({ filtros: { ...values, page: 1 } });
  };

  const renderActions = (elemento: NivelI) => {
    return (
      <NivelRowActions
        elemento={elemento}
        onClickEdit={handleEdit}
        refreshTable={refreshTable}
      />
    );
  };

  useEffect(() => {
    searchNiveles({ filtros: { ...values, limit, page } });
  }, [values]);

  return (
    <section>
      <h1 className="section-title">Niveles</h1>

      <h2 className="section-subtitle mt-2">
        Desde aquí podrás gestionar los niveles.
      </h2>

      <div className="d-flex justify-content-between mt-4 mb-3">
        <div className="d-flex column-gap-3">
          <Input
            size="sm"
            id="nombre"
            onChange={handleChangeWithResetPage}
            placeholder="Buscar"
            values={values}
            startIcon={<LupaIcon />}
          />
          <Button
            size="sm"
            variant="secondary"
            className="clear-filters-button"
            onClick={handleClearFilters}
            disabled={!values.nombre}
          >
            Limpiar filtros
          </Button>
        </div>
        <Button size="lg" onClick={handleCreate}>
          Nuevo Nivel
        </Button>
        <NivelABM
          showModal={showModalABM}
          actionType={actionType}
          onClose={handleCloseModal}
          elemento={selectedElement}
          onSuccess={refreshTable}
        />
      </div>

      {isLoading && (
        <div className="d-flex justify-content-center w-full">
          <Spinner />
        </div>
      )}

      {!isLoading && elementos && cantidad != undefined && (
        <>
          <NivelTable elementos={elementos} renderActions={renderActions} />
          <Pagination
            totalItems={cantidad}
            currentPage={page}
            currentLimit={limit}
            onChangePage={handleChangePagination}
            showPaginationOnlyOnMoreThanPages={1}
          />
        </>
      )}
    </section>
  );
};
